import { REACT_APP_URL_COMUNI } from './../config';
import { get, put } from '../utility/http';

export async function fetchDroni() {
  try {
    const response = await get(
      '/asset-management/assets/standalone/true',
      true,
      {}
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchBoundComune(comune: string) {
  try {
    const response = await get(
      `${REACT_APP_URL_COMUNI}?include=extent&srid=4326&filter=comune eq ${comune}`,
      true,
      {},
      false,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchEditTask(body: any) {
  try {
    const response = await put(`/tasks/tasks/${body.id}?projection=3857`, true, {}, body);
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}